export default __webpack_public_path__ + "static/media/cvv.cd6ccf91.svg";